import { IFormProjectFinishPosition } from 'models/Forms/Evaluation';
import { ReactText } from 'react';
import api from './config/api';

export const getTPAFinishPosition = (numberPositionForm: number, idForm: ReactText) =>
  api.get<IFormProjectFinishPosition>(
    `/lei-geral-protecao-de-dados/assessment-terceiros/tab/finish/position?id=${idForm}&position=${numberPositionForm}`,
  );
